import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";
import { WelderProcess } from "@/api/williams/welders";

export function useRevokeProcess(welderId: string) {
  const queryClient = useQueryClient();

  return useMutation(async (process: WelderProcess) => {
    await api.revokeProcess(welderId, process);
    queryClient.invalidateQueries(queryKeys.welder.status(welderId, {}));
    queryClient.invalidateQueries(queryKeys.welder.processStatus(welderId));
    queryClient.invalidateQueries(queryKeys.welder.statusHistory(welderId));
    queryClient.invalidateQueries(queryKeys.expirations.list());
  });
}
